export default __webpack_public_path__ + "static/media/ph_userA.6c8661a7.png";